import styled from "@emotion/styled";
import { Button, LightMode, Tab, Tabs, Variables, gearIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { ButtonsContainer, CustomerModeToggle, FlexDiv, Line } from "@repo/ui";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  padding: 0 24px;
  background-color: ${LightMode.colourStaticWhite};
`;

interface Props<T extends string> {
  activeTabPanelId: T;
  tabs: { label: string; tabPanelId: T; url?: string }[];
  onClick?: (id: T) => void;
  line?: boolean;
  button?: boolean;
}

export function SecondLevelHeader<T extends string>({
  onClick,
  tabs,
  activeTabPanelId,
  line,
  button,
}: Props<T>) {
  const navigate = useNavigate();
  return (
    <Container>
      <FlexDiv
        justifyContent="space-between"
        alignItems="center"
        gap={Variables.space50}
      >
        <Tabs
          activeTab={activeTabPanelId}
          tabs={tabs.map((tab) => (
            <Tab
              key={tab.tabPanelId}
              text={tab.label}
              tabPanelId={tab.tabPanelId}
              onClick={() => {
                if (onClick) {
                  onClick(tab.tabPanelId);
                } else if (tab.url) {
                  navigate(tab.url);
                }
              }}
            />
          ))}
        />
        <ButtonsContainer>
          {button && (
            <Button
              text={t("action.customize")}
              aria-label="icon-button"
              ssrIcon={gearIcon}
              size="small"
              onClick={() => {
                navigate("/customize");
              }}
            />
          )}
          <CustomerModeToggle />
        </ButtonsContainer>
      </FlexDiv>
      {line && <Line />}
    </Container>
  );
}
